import {createAction, props} from '@ngrx/store';
import {DriverModel} from '../../../scoring/models/driver.model';
import {ScoringRankModel} from '../../../scoring/models/scoring-rank.model';
import {RankTypeEnum} from '../../../scoring/models/rank-type.enum';
import {ScoringSummaryModel} from '../../../scoring/models/scoring-summary.model';
import {PeriodStatsModel} from '../../../scoring/models/period-stats.model';
import {PeriodTypeEnum} from '../../../shared/models/period-type.enum';
import { DriverScoringSummaryResponseModel } from 'src/app/scoring/models/driver-scoring-summary-response.model';


export const getDriverList = createAction(
  '[Scoring] Get Driver List',
);
export const getDriverListSuccess = createAction(
  '[Scoring/API] Get Driver List Success',
  props<{data: DriverModel[]}>()
);
export const getDriverListFailure = createAction(
  '[Scoring/API] Get Driver List Failure',
  props<{error: any}>()
);

export const getDriverScoring = createAction(
  '[Scoring] Get Driver Scoring',
);

export const getDriverScoringSuccess = createAction(
  '[Scoring/API] Get Driver Scoring Success',
  props<{data: DriverScoringSummaryResponseModel[]}>()
);
export const getDriverScoringFailure = createAction(
  '[Scoring/API] Get Driver Scoring Failure',
  props<{error: any}>()
);



export const changeDateRange = createAction(
  '[Scoring] Change Date Range',
  props<{dateFrom: Date, dateTo: Date}>()
);

export const getVehiclesSummary = createAction(
  '[Scoring] Get Vehicles Summary'
);
export const getVehiclesSummarySuccess = createAction(
  '[Scoring/API] Get Vehicles Summary Success',
  props<{data: ScoringSummaryModel}>()
);
export const getVehiclesSummaryFailure = createAction(
  '[Scoring/API] Get Vehicles Summary Failure',
  props<{error: any}>()
);


export const getVehiclesPeriodStats = createAction(
  '[Scoring] Get Vehicles Period Stats'
);
export const getVehiclesPeriodStatsSuccess = createAction(
  '[Scoring/API] Get Vehicles Period Stats Success',
  props<{data: PeriodStatsModel}>()
);
export const getVehiclesPeriodStatsFailure = createAction(
  '[Scoring/API] Get Vehicles Period Stats Failure',
  props<{error: any}>()
);

export const getRankingData = createAction(
  '[Scoring] Get Ranking Data',
  props<{rank: RankTypeEnum}>()
);
export const getRankingDataSuccess = createAction(
  '[Scoring/API] Get Ranking Data Success',
  props<{data: ScoringRankModel[], rank: RankTypeEnum}>()
);
export const getRankingDataFailure = createAction(
  '[Scoring/API] Get Ranking Data Failure',
  props<{error: any}>()
);

export const setDriver = createAction(
  '[Scoring] Set Driver',
  props<{id: number}>()
);
export const setDriverSuccess = createAction(
  '[Scoring/API] Set Driver Success',
  props<{data: DriverModel}>()
);
export const setDriverFailure = createAction(
  '[Scoring/API] Set Driver Failure',
  props<{error: any}>()
);


export const getDriverSummary = createAction(
  '[Scoring] Get Driver Summary'
);
export const getDriverSummarySuccess = createAction(
  '[Scoring/API] Get Driver Summary Success',
  props<{data: ScoringSummaryModel}>()
);
export const getDriverSummaryFailure = createAction(
  '[Scoring/API] Get Driver Summary Failure',
  props<{error: any}>()
);


export const getDriverPeriodStats = createAction(
  '[Scoring] Get Driver Period Stats'
);
export const getDriverPeriodStatsSuccess = createAction(
  '[Scoring/API] Get Driver Period Stats Success',
  props<{data: PeriodStatsModel}>()
);
export const getDriverPeriodStatsFailure = createAction(
  '[Scoring/API] Get Driver Period Stats Failure',
  props<{error: any}>()
);

export const getSelectedDriverSummary = createAction(
  '[Scoring] Get Selected Driver Summary'
);
export const getSelectedDriverSummarySuccess = createAction(
  '[Scoring/API] Get Selected Driver Summary Success',
  props<{data: ScoringSummaryModel}>()
);
export const getSelectedDriverSummaryFailure = createAction(
  '[Scoring/API] Get Selected Driver Summary Failure',
  props<{error: any}>()
);


export const getSelectedDriverPeriodStats = createAction(
  '[Scoring] Get Selected Driver Period Stats',
  props<{periodType?: PeriodTypeEnum}>()
);
export const getSelectedDriverPeriodStatsSuccess = createAction(
  '[Scoring/API] Get Selected Driver Period Stats Success',
  props<{data: PeriodStatsModel}>()
);
export const getSelectedDriverPeriodStatsFailure = createAction(
  '[Scoring/API] Get Selected Driver Period Stats Failure',
  props<{error: any}>()
);

export const getDriverRankData = createAction(
  '[Scoring] Get Driver Rank Data',
  props<{id: number}>()
);
export const getDriverRankDataSuccess = createAction(
  '[Scoring/API] Get Driver Rank Data Success',
  props<{data: ScoringRankModel[]}>()
);
export const getDriverRankDataFailure = createAction(
  '[Scoring/API] Get Driver Rank Data Failure',
  props<{error: any}>()
);



export const getGroupsSummary = createAction(
  '[Scoring] Get Groups Summary'
);
export const getGroupsSummarySuccess = createAction(
  '[Scoring/API] Get Groups Summary Success',
  props<{data: ScoringSummaryModel}>()
);
export const getGroupsSummaryFailure = createAction(
  '[Scoring/API] Get Groups Summary Failure',
  props<{error: any}>()
);


export const getGroupsPeriodStats = createAction(
  '[Scoring] Get Groups Period Stats'
);
export const getGroupsPeriodStatsSuccess = createAction(
  '[Scoring/API] Get Groups Period Stats Success',
  props<{data: PeriodStatsModel}>()
);
export const getGroupsPeriodStatsFailure = createAction(
  '[Scoring/API] Get Groups Period Stats Failure',
  props<{error: any}>()
);

export type ScoringActionsUnion = ReturnType<
  typeof getDriverList |
  typeof getDriverListSuccess |
  typeof getDriverListFailure |
  typeof getDriverScoring |
  typeof getDriverScoringSuccess |
  typeof getDriverScoringFailure |
  typeof changeDateRange |
  typeof getRankingData |
  typeof getRankingDataSuccess |
  typeof getRankingDataFailure |
  typeof getVehiclesSummary |
  typeof getVehiclesSummarySuccess |
  typeof getVehiclesSummaryFailure |
  typeof getVehiclesPeriodStats |
  typeof getVehiclesPeriodStatsSuccess |
  typeof getVehiclesPeriodStatsFailure |
  typeof setDriver |
  typeof setDriverSuccess |
  typeof setDriverFailure |
  typeof getDriverSummary |
  typeof getDriverSummarySuccess |
  typeof getDriverSummaryFailure |
  typeof getDriverPeriodStats |
  typeof getDriverPeriodStatsSuccess |
  typeof getDriverPeriodStatsFailure |
  typeof getSelectedDriverSummary |
  typeof getSelectedDriverSummarySuccess |
  typeof getSelectedDriverSummaryFailure |
  typeof getSelectedDriverPeriodStats |
  typeof getSelectedDriverPeriodStatsSuccess |
  typeof getSelectedDriverPeriodStatsFailure |
  typeof getDriverRankData |
  typeof getDriverRankDataSuccess |
  typeof getDriverRankDataFailure |
  typeof getGroupsSummary |
  typeof getGroupsSummarySuccess |
  typeof getGroupsSummaryFailure |
  typeof getGroupsPeriodStats |
  typeof getGroupsPeriodStatsSuccess |
  typeof getGroupsPeriodStatsFailure
  >;

